import React, { CSSProperties, ReactNode } from 'react';

const styles: { [key: string]: CSSProperties } = {
    container: {
    // Layout
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    
    // Dimensions
    width: '100%',
    height: '52px',
    
    // Spacing
    padding: '8px 16px',
    
    // Background
    backgroundColor: '#F9FAFB',

    // Only top corners rounded
    borderRadius: '14px 14px 0 0',
  },

  partyName: {
    // Reset default h2 styles
    margin: '0',
    
    // Typography
    fontSize: '18px',
    fontFamily: "Inter",
    fontWeight: '500',
    color: '#0A0A0A',
    lineHeight: '28px',
    
    // Layout
    padding: '6px 0',
    
    // Text overflow
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  partyTypeBadge: {
    // Dimensions
    height: '20px',
    
    // Spacing
    padding: '0 8px',
    
    // Typography
    fontSize: '12px',
    fontWeight: '600',
    lineHeight: '20px',
    color: "#4B5563",
    
    // Background and borders
    backgroundColor: "#D1D5DB",
    borderRadius: '14px',

    // Layout
    display: 'inline-flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
  },

  rightContent: {
    // Layout
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    
    // Push to the right
    marginLeft: 'auto',
  }
}


interface ReportHeaderProps {
  partyName: string;
  partyType?: string;
  className?: string;
  rightContent?: ReactNode;
}

const ReportHeader: React.FC<ReportHeaderProps> = ({
  partyName,
  partyType,
  rightContent,
  className = '',
}) => {
  return (
    <div style={styles.container} className={className}>
      <h2 style={styles.partyName}>{partyName}</h2>
      {partyType && (
        <span style={styles.partyTypeBadge}>{partyType}</span>
      )}
      {rightContent && (
        <div style={styles.rightContent}>
          {rightContent}
        </div>
      )}
    </div>
  );
};

export default ReportHeader;